








import {
  Component, Vue, Watch, mixins,
} from '@samclick-commons';
import SamclickMixins from '@/utils/mixins';
import ResultTab from '@/views/Reports/Achievement/ResultTab.vue';

class AchievementReportState {
    activeTab: string = 'result'
}

@Component({
  /**
   * Imported components
   * */
  components: {
    ResultTab,
  },
  /**
   * Stores values
   * */
  computed: {},
  /**
   * Component properties
   * */
  props: {},
})
export default class AchievementReport extends mixins(SamclickMixins) {
  /**
   * Local state
   * */
    state = new AchievementReportState();

  /**
   * Watchers
   * */
  @Watch('componentState.var')
    sampleWatcher(newVal: string, oldVal: string) {

    }

  /**
   * Methods
   * */
  actionMethod() {

  }


  /**
   * Computed
   * */
  get computedVal() {
    return {};
  }

  /**
   * Lifecycle hooks
   * */
  created() {}

  mounted() {}

  beforeUpdate() {}
}
